import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { EditAddonButton } from './editAddonButton';

type Props = {
  addonIds: string[];
  onClose: () => void;
};

export const AddOnsSelectionPanelMain = ({ addonIds, onClose }: Props) => {
  const { t } = useTranslation();

  // Edit targets a single add-on, so only surface the action with exactly
  // one selection.
  const addonId = addonIds.length === 1 ? addonIds[0] : undefined;

  return (
    <View style={styles.container}>
      {addonId && (
        <EditAddonButton
          addonId={addonId}
          label={t('addOn.edit.label')}
          onClose={onClose}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 16,
    gap: 12,
  },
});
